import React from 'react';
import PropTypes from 'prop-types';
import { BorderlessIframe } from './styles';
import { useLayout } from '../layout/context';
import { Container } from '../styled/containers';

const IframeEmbed = ({ title, src, height, width }) => {
  const { insideContainer, insideTwoThirds, insideHalfWidth } = useLayout();
  const narrowContainer = insideTwoThirds || insideHalfWidth;

  return (
    <Container $padding={!narrowContainer && !insideContainer}>
      <BorderlessIframe title={title} src={src} style={{ height, width }} />
    </Container>
  );
};

IframeEmbed.propTypes = {
  title: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default IframeEmbed;

export const IframeEmbedAssembly = ({ contentfulData }) => (
  <IframeEmbed
    title={contentfulData.title}
    src={contentfulData.src}
    width={contentfulData.width}
    height={contentfulData.height}
  />
);

IframeEmbedAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
